<template>
  <view-page
    baseRoute="facilities"
    :entity='entity'
    :button-access="componentAccess"
    :model-entity="modelEntity"
  >
    <template v-slot="{ model }">
      <vs-alert color="warning" title="Deleted Record" v-if="model.IsDeleted" class="mb-4">
        <span>You are viewing the record for a deleted facility</span>
      </vs-alert>
      <facility-form
        v-if="model"
        :readonly="readonly"
        v-model="model"
        card-title="Details"
      />
    </template>

    <template v-slot:extra-button="{ model }">
      <vs-button
        v-if="model && componentAccess.canPublish.access"
        class="mt-2 ml-4"
        color="light"
        @click="openPublishAlert(model)"
      >
        {{ model.IsPublished ? "Unpublish" : "Publish" }}
      </vs-button>
      <vs-button
          v-if="model && componentAccess.canEnable.access"
          class="mt-2 ml-4"
          color="light"
          @click="openEnableAlert(model)"
      >
        {{ model.IsEnabled ? "Deactivate" : "Activate" }}
      </vs-button>
    </template>
  </view-page>
</template>

<script>
import ViewPage from '@/views/components/Views/ViewPage';
import FacilityForm from '@/views/pages/facilities/FacilityForm';
import NotificationMixin from '@/components/mixins/NotificationMixin';
import EnablePublishMixin from '../../../components/mixins/EnablePublishMixin';

export default {
  name: 'FacilityView',
  components: {
    FacilityForm,
    ViewPage
  },
  mixins: [NotificationMixin, EnablePublishMixin],
  data() {
    return {
      model: null,
      entity: 'Facility',
      readonly: true,
      modelEntity: this.$api.facilities,
      componentAccess: {
        canEdit: {
          route: 'facilities.edit',
          access: false
        },
        canDelete: {
          route: 'facilities.delete',
          access: false
        },
        canRestore: {
          route: 'facilities.restore',
          access: false
        },
        canPublish: {
          route: 'facilities.publish',
          access: false
        },
        canEnable: {
          route: 'facilities.publish',
          access: false
        }
      }
    };
  }
};
</script>

<style scoped>
</style>
